/** 能源 — 设备用电 /energy/equipmentPower */
export default {
  equipmentPower: {
    filterStatPeriod: '统计时间',
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    filterTenant: '选择租户',
    phTenant: '请选择租户',
    filterMeter: '选择电表',
    phMeter: '请输入序列号或选择电表',
    exportLoading: '导出中...',
    exportReport: '导出报表',
    loadingText: '数据加载中...',
    sectionTitle: '电表用电',
    sectionTip: '请选择电表查看详细数据',
    maxDemandLabel: '最大需量：',
    collectTimeLabel: '采集时间：',
    totalFeeLabel: '合计电费：',
    totalElecLabel: '合计电量：',
    unitKw: 'kW',
    unitYuan: '元',
    unitKwh: '度',
    unitKwLower: 'kw',
    colEquipment: '设备信息',
    colBindInfo: '绑定信息',
    colDate: '日期',
    colDemandRecord: '需量记录',
    colTotalFee: '总费用(元)',
    colEnergyKwh: '电量(度)',
    colStartEnd: '起止读数',
    colTime: '时间',
    colTotalElecCol: '总电量(度)',
    touSharp: '尖',
    touPeak: '峰',
    touFlat: '平',
    touValley: '谷',
    metricMaxDemand: '最大需量：',
    metricCollectTime: '采集时间：',
    metricTotalFee: '总费用：',
    metricTotalElec: '总电量：',
    seStart: '起',
    seEnd: '止',
    dash: '—',
    emptyNoData: '暂无数据',
    emptySelectMeter: '请选择电表序列号或电表后查看数据',
    serialPrefix: '序列号',
    bindDedicated: '专用表',
    bindPublic: '公摊表',
    bindFormula: '公式表',
    bindAc: '空调表',
    tenantAll: '全部',
    pickerLast7: '最近7天',
    pickerLast15: '最近15天',
    pickerLast30: '最近30天',
    pickerThisMonth: '本月',
    pickerLastMonth: '上月',
    msgTenantListFail: '获取租户列表失败',
    msgMeterListFail: '获取电表列表失败',
    msgSelectDate: '请选择统计时间',
    msgSelectMeter: '请选择电表',
    msgNoData: '未查询到数据',
    msgFetchFail: '获取数据失败',
    msgExportEmpty: '暂无数据可导出',
    msgExportOk: '导出成功！',
    msgExportFail: '导出失败',
    msgExportRetry: '请重试',
    exportFilterLine: '统计时间: {start} 至 {end}  |  租户: {tenant}  |  电表: {meter}',
    exportSheetName: '电表用电报表',
    exportFilePrefix: '电表用电报表',
    expColMeterId: '电表编号',
    expColMeterName: '电表名称',
    expColSerial: '电表序列号',
    expColBindType: '电表绑定类型',
    expColBindId: '绑定ID',
    expColBindName: '绑定信息',
    expColDate: '日期',
    expColTotalFee: '总电费(元)',
    expColTotalKwh: '总电量(度)',
    expColKwhSharp: '尖电量(度)',
    expColKwhPeak: '峰电量(度)',
    expColKwhFlat: '平电量(度)',
    expColKwhValley: '谷电量(度)',
    expRowStartRead: '起始读数',
    expRowStopRead: '截止读数',
    expSubTime: '时间',
    expSubTotal: '总电量',
    expSubSharp: '尖',
    expSubPeak: '峰',
    expSubFlat: '平',
    expSubValley: '谷',
    msgNoSerial: '该设备缺少序列号，无法跳转',
    msgBindNotTenant: '当前绑定类型不是租户，无法跳转',
    msgNoTenantId: '缺少租户ID，无法跳转'
  }
}
